import { Box, Flex, styled } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';

export const StyledStickyContainer = styled(Box)<{ backgroundColor: string; isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  backdrop-filter: blur(0.25rem);
  -webkit-backdrop-filter: blur(0.25rem);
  transition: ${animationTransition('transform')};
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  transform: translate3d(0, ${props => (props.isVisible ? '0' : '-100%')}, 0);
  will-change: transform;
  backface-visibility: hidden;
`;

export const StyledContentWrapper = styled(Flex)<{ isFullWidth?: boolean }>`
  width: 100%;
  max-width: ${props => (props.isFullWidth ? '100%' : '64rem')};
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  justify-content: center;
  box-sizing: content-box;
`;
